import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message } from "antd";
// import AmCharts from "@amcharts/amcharts3-react";
import { LoadingOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_sunburst from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import EventEditModal from "./EventEditModal";

am4core.useTheme(am4themes_animated);

const GanttChart = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chartRef = useRef(null);
  const [stateData, setStateData] = useState({
    visible: false,
    selectedEventData: null,
  });

  useEffect(() => {
    let chart = am4core.create(
      props.divId ? props.divId : "DivID",
      am4charts.XYChart
    );

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.paddingRight = 30;
    chart.dateFormatter.inputDateFormat = "yyyy/MM/dd";

    var colorSet = new am4core.ColorSet();
    colorSet.saturation = 0.4;
    chart.data = props.data.newData;

    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "groupLabel";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.inversed = true;
    categoryAxis.renderer.labels.template.fill = am4core.color(
      "rgba(255, 255, 255, 0.65)"
    );

    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.dateFormatter.dateFormat = "yyyy/MM/dd";
    dateAxis.renderer.minGridDistance = 70;
    dateAxis.baseInterval = { count: 30, timeUnit: "minute" };
    // dateAxis.max = new Date(2018, 1, 31).getTime();
    dateAxis.strictMinMax = true;
    dateAxis.renderer.tooltipLocation = 0;
    dateAxis.renderer.labels.template.fill = am4core.color(
      "rgba(255, 255, 255, 0.65)"
    );

    // Create series
    function createSeries(itemId, cat, fromDate, tofield, color, tooltipName) {
      // var series = chart.series.push(new am4charts.ColumnSeries());
      // series.dataFields.valueX = field;
      // series.dataFields.categoryY = "year";
      // series.name = name;
      // series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
      // series.columns.template.height = am4core.percent(100);
      // series.sequencedInterpolation = true;

      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.columns.template.width = am4core.percent(80);
      series1.columns.template.tooltipText =
        "{" + tooltipName + "}: {openDateX} - {dateX}";
      series1.dataFields.openDateX = fromDate;
      series1.dataFields.dateX = tofield;
      series1.dataFields.itemId = itemId;
      series1.dataFields.categoryY = cat;
      series1.columns.template.propertyFields.fill = color; // get color from data
      series1.columns.template.propertyFields.stroke = color;
      series1.columns.template.strokeOpacity = 1;
      series1.sequencedInterpolation = true;
      series1.columns.template.events.on(
        "hit",
        function (ev) {
          
          if (ev.target.dataItem.dataContext.itemid) {
            const data = props.data.data.filter(
              (item) => item.itemid === ev.target.dataItem.dataContext.itemid
            );
            setStateData({ visible: true, selectedEventData: data });
            
          }
        },
        this
      );

      var valueLabel = series1.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{valueX}";
      valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dx = 10;
      valueLabel.label.hideOversized = false;
      valueLabel.label.truncate = false;
      valueLabel.label.fill = am4core.color("rgba(255, 255, 255, 0.65)");

      var categoryLabel = series1.bullets.push(new am4charts.LabelBullet());
      // categoryLabel.label.text = "{name}";
      categoryLabel.label.horizontalCenter = "right";
      categoryLabel.label.dx = -10;
      // categoryLabel.label.fill = am4core.color("#fff");
      categoryLabel.label.hideOversized = false;
      categoryLabel.label.truncate = false;
      categoryLabel.label.fill = am4core.color("rgba(255, 255, 255, 0.65)");
    }
    // props.data.forEach(element => {

    // });
    createSeries(
      "itemid",
      "groupLabel",
      "series1FromDate",
      "series1ToDate",
      "series1Color",
      "series1TooltipLabel"
    );
    createSeries(
      "itemid",
      "groupLabel",
      "series2FromDate",
      "series2ToDate",
      "series2Color",
      "series2TooltipLabel"
    );

    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarX.background.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.background.fillOpacity = 0.8;
    chart.scrollbarX.thumb.background.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.thumb.background.fillOpacity = 1;
    chart.scrollbarX.startGrip.background.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.endGrip.background.fill = am4core.color("#A5A5A5");
    // Applied on hover
    chart.scrollbarX.startGrip.background.states.getKey(
      "hover"
    ).properties.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.endGrip.background.states.getKey(
      "hover"
    ).properties.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.thumb.background.states.getKey(
      "hover"
    ).properties.fill = am4core.color("#A5A5A5");

    // Applied on mouse down
    chart.scrollbarX.startGrip.background.states.getKey(
      "down"
    ).properties.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.endGrip.background.states.getKey(
      "down"
    ).properties.fill = am4core.color("#A5A5A5");
    chart.scrollbarX.thumb.background.states.getKey(
      "down"
    ).properties.fill = am4core.color("#A5A5A5");

    return () => {
      chart.dispose();
    };
  }, [props.data]);

  const modelCloseHandler = (needRefetch) => {
    setStateData({ visible: false, selectedEventData: null });
    if (needRefetch) {
      props.refatchData();
    }
  };

  return (
    <div>
      {/* <div id={(props.divId) ? props.divId : "DivID"} style={{ width: "100%", height: "330px" }}></div> */}
      <div
        id={props.divId ? props.divId : "DivID"}
        style={{
          width: "100%",
          height:
            props.data &&
            props.data.Config &&
            props.data.Config.heightOfGanttChart
              ? props.data.Config.heightOfGanttChart
              : "400px",
        }}
      ></div>
      <EventEditModal
        visible={stateData.visible}
        modelCloseHandler={modelCloseHandler}
        data={stateData.selectedEventData}
        items={props.items}
      />
    </div>
  );
};

export default GanttChart;
